export enum BroadcastGroup {
  ALL_USERS = "ALL_USERS",
  ALL_LEARNERS = "ALL_LEARNERS",
  ALL_INSTRUCTORS = "ALL_INSTRUCTORS",
}
